// extracted by mini-css-extract-plugin
export default {"file_box":"FileBox_file_box__8pbQN","file_name":"FileBox_file_name__m0I4m","img_file_box":"FileBox_img_file_box__2cJ5+"};